<template>
  <div v-if="this.getUser && this.localDoctor">
    <b-row>
      <b-col lg="10">
        <h2 class="page-title">Doctor's - <span class="fw-semi-bold">Profile</span></h2>
      </b-col>
      <b-col>
          <b-button :variant="(status_form.status===0)? 'danger' : 'success'" v-model="status_form.status" style="margin-left: 22%; margin-bottom: 8px;" @click="setActiveStatus">{{activationbutton}}</b-button>
      </b-col>
      <b-col>
           <b-button variant="outline-info" style="margin-left: 10px; margin-bottom: 8px;" @click="setmodal">edit</b-button>
      </b-col>
    </b-row>
    <b-row>
        <b-col lg="12">
          <b-row>
            <b-col lg="3">
              <widget style="padding: 0px;">
                <img :src="localDoctor.image" class="img" alt="team" @error="(e)=>e.target.src=require('./../../../../public/assets/img/default_doctor_image.png')">
                <widget style="margin-bottom: 0px; ">
                  <div style="margin-top: 5px;">
                    <h3 class="textdecorationName">{{ localDoctor.name }}</h3>
                    <h5 class="textdecorationName"><b>Balance: </b>{{ localDoctor.pending_amount }}</h5>
                    <p class="textmargin1px textColorBlue">{{localDoctor.designation}}</p>
                    <span class="textColorBlue" >{{localDoctor.workplace}}</span>
                  </div>
                </widget>
              </widget>
                <widget>
                  <h3>Personal Info</h3>
                  <ul>
                    <li>Mobile:<span class="margin-lf-2px">{{localDoctor.mobile}}</span></li>
                    <li>E-mail:<span class="margin-lf-2px"><code>{{localDoctor.email}}</code></span></li>
                    <li>BMDC Number:<span class="margin-lf-2px">{{localDoctor.bmdc_number}}</span> </li>
                    <li>Doctor Type ID:<span class="margin-lf-2px">{{localDoctor.doctortype_id}}</span></li>
                  </ul>
                </widget>
            </b-col>
            <b-col>
              <widget>
                <div class="single-item margintop">
                  <div class="table-responsive">
                    <h3>Appointment Rates:</h3>
                    <table class="table">
                      <tbody>
                      <tr>
                        <th>Rate :</th>
                        <td class="table-data">{{localDoctor.rate}}</td>
                      </tr>
                      <tr>
                        <th>Offer Rate :</th>
                        <td class="table-data">{{localDoctor.offer_rate}}</td>
                      </tr>
                      <tr>
                        <th>Report Follow Up Rate :</th>
                        <td class="table-data">{{localDoctor.report_followup_rate}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </widget>
              <widget>
                <div class="single-item margintop">
                  <div class="table-responsive">
                    <h3>Education:</h3>
                    <table class="table">
                      <tbody>
<!--                      <tr>-->
<!--                        <th>Medical College :</th>-->
<!--                        <td class="table-data">{{ localDoctor.medical_college}}</td>-->
<!--                      </tr>-->
                      <tr>
                        <th>Post Grade :</th>
                        <td class="table-data">{{localDoctor.postgrad}}</td>
                      </tr>
                      <tr>
                        <th>Other Trainings :</th>
                        <td class="table-data">{{localDoctor.other_trainings}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </widget>
            </b-col>
          </b-row>
        </b-col>
    </b-row>
    <b-modal ref="my-modal" centered title="Ekhoni Daktar">
      <b-row>
        <b-col>
          <div>
            <img :src="previewImage" class="uploading-image img" alt=""/>
            <input type="file" accept="image/jpeg" @change=uploadImage >
          </div>
        </b-col>
      </b-row>

      <b-form class="mt-2">
        <b-form-group id="work_place_group" label="Work Place:" label-for="work_place" description="Please give the Name of Your New Work Place">
          <b-form-input id="work_place" v-model="edit_form.workplace" type="text"></b-form-input>
        </b-form-group>
        <b-form-group id="designation_group" label="Designatiom:" label-for="designation" description="Please Enter Your New Designation">
          <b-form-input id="designation" v-model="edit_form.designation" type="text" ></b-form-input>
        </b-form-group>
        <b-form-group id="others_training_group" label="Other Traingings:" label-for="Work Place">
          <b-form-textarea id="others_training" v-model="edit_form.other_trainings" type="text" rows="1" max-rows="3"></b-form-textarea>
        </b-form-group>
      </b-form>

      <b-row>
        <b-col>
          <b-form-group id="rate_group" label="Rate:" label-for="rate" description="Enter New Rate">
            <b-form-input id="rate" v-model="edit_form.rate" type="number"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="offer_rate_group" label="Offer Rate:" label-for="offer_rate" description="Enter New Offer Rate">
            <b-form-input id="offer_rate" v-model="edit_form.offer_rate" type="number"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group id="first_appointment_rate" label="First Appointment Rate:" label-for="first_appointment_rate" description="Enter New First Appiontment Rate">
            <b-form-input id="first_appointment_rate" v-model="edit_form.first_appointment_rate" type="number"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="report_followup_rate" label="Report Followup Rate:" label-for="report_followup_rate" description="Enter New Report Followup Rate">
            <b-form-input id="report_followup_rate" v-model="edit_form.report_followup_rate" type="number"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <template v-slot:modal-footer>
        <b-button size="sm" variant="danger" @click="cancel">
          CANCEL
        </b-button>
        <b-button size="sm" variant="success" @click="save">
          SAVE
        </b-button>
      </template>
    </b-modal>

    <b-modal ref="activation_modal" centered title="Ekhoni Daktar">
      <b-form class="mt-2">
        <b-form-group id="end_time_group" label="End Time:" label-for="end_time" description="Please enter your ending time">
          <b-form-timepicker id="end_time" required v-model="modalEndTime"></b-form-timepicker>
        </b-form-group>
      </b-form>

      <template v-slot:modal-footer>
        <b-button size="sm" variant="success" @click="saveTime">
          SAVE
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {Form} from 'vform';
import AuthService from '@/services/doctor/auth.service'
import moment from "moment";
import 'vue2-timepicker/dist/VueTimepicker.css';


export default {
  name: "Profile",
  components:{
  },
  data(){
    return{
      edit_form: new Form(
          {
            rate: null,
            offer_rate: null,
            first_appointment_rate: null,
            report_followup_rate: null,
            workplace: ' ',
            designation: ' ',
            other_trainings: ' ',
          }
      ),
      status_form: new Form({
        status: '',
      }),
      localDoctor: null,
      modalEndTime: '',
      time_form: new Form(
          {
            doctor_id: null,
            start_time: '',
            end_time: ''
          }
      ),
      previewImage: null,
      FILE: null,
      activationbutton: '',
    };
  },
  computed: {
    ...mapGetters('doctorAuth', ['getUser']),
  },
  methods:{
      ...mapActions('doctorAuth', ['storeUser']),
      setmodal(){
        this.edit_form.fill(this.getUser.doctor);
        this.$refs['my-modal'].show();
      },
      cancel(){
        this.$refs['my-modal'].hide();
        this.previewImage=null;
      },
      uploadImage(e){
        console.log(e);
        if(e.target.files.length>0){
          this.FILE = e.target.files[0];
          const reader = new FileReader();
          if(this.FILE!==null){
            reader.readAsDataURL(this.FILE);
            reader.onload = e =>{
              this.previewImage = e.target.result;
            };
          }
        }
      },
      setActiveStatus(){
        //this.status_form.status=0;
        console.log(this.status_form.status);
        if(this.status_form.status===0){
          this.$refs['activation_modal'].show();
        }
        if(this.status_form.status===1){
          this.status_form.status=0;
          this.activationbutton= 'Inactive';
          this.changeActiveStatusService()
          this.time_form.start_time='';
          this.time_form.end_time='';
          this.modalEndTime='';
        }
      },
      saveTime(){
        if(this.modalEndTime!==''){
          console.log(this.time_form);
          this.time_form.doctor_id = this.getUser.doctor.id;


          this.time_form.start_time=moment(String(new Date())).add(1, 'minutes').format("YYYY-MM-DDTHH:mm:ss.SZ");

          let end = this.modalEndTime.split(':');
          this.time_form.end_time = new Date();
          this.time_form.end_time.setHours(parseInt(end[0]), parseInt(end[1]));
          this.time_form.end_time = moment(String(this.time_form.end_time)).format("YYYY-MM-DDTHH:mm:ss.SZ");

          this.$refs['activation_modal'].hide();
          console.log(this.time_form);
          AuthService.setLiveCallSchedule(this.time_form)
              .then((resposne) => {
                if (resposne.status === 201) {
                  alert("Doctor updated");
                  console.log(resposne);

                  if (this.status_form.status === 1) {
                    this.status_form.status = 0;
                    this.activationbutton= 'Inactive';
                  } else {
                    this.status_form.status = 1;
                    this.activationbutton= 'Active';
                  }
                  this.changeActiveStatusService();
                  // this.storeUser(resposne.data);
                } else {
                  alert("could not update doctor")
                }
              })

          this.time_form.clear();
        }
        else{
          alert("Please enter end time");
        }
      },
      changeActiveStatusService(){
        AuthService.changeActiveStatus(this.status_form)
            .then((resposne) => {
              if (resposne.status === 204) {
                alert("Doctor Activation set");
                // this.storeUser(resposne.data);
              }
              else{
                alert("could not update doctor")
              }
            })
      },
      save(){
        this.$refs['my-modal'].hide();
        this.saveEditedInformation();
        if(this.FILE!==null){
          this.saveImage();
        }
      },
      saveEditedInformation(){
        console.log(this.edit_form);
                AuthService.updateDoctorInfo(this.edit_form,this.getUser.doctor.id)
                .then((resposne) => {
                    if (resposne.status === 204) {
                        alert("Doctor updated");
                        this.showupdatedInformation();
                       // this.storeUser(resposne.data);
                    }
                    else{
                        alert("could not update doctor")
                    }
                })
      },
      showupdatedInformation(){
        this.localDoctor.rate=  this.edit_form.rate;
        this.localDoctor.offer_rate=  this.edit_form.offer_rate;
        this.localDoctor.first_appointment_rate= this.edit_form.first_appointment_rate;
        this.localDoctor.report_followup_rate= this.edit_form.report_followup_rate;
        this.localDoctor.workplace=  this.edit_form.workplace;
        this.localDoctor.designation=  this.edit_form.designation;
        this.localDoctor.other_trainings= this.edit_form.other_trainings;
      },

      saveImage(){
          let formData = new FormData()
          formData.append('image', this.FILE );
          AuthService.uploadImage(formData,this.getUser.doctor.id).then((resposne)=>{
              if (resposne.status === 200) {
                alert("Image updated");
                this.localDoctor.image= `${process.env.VUE_APP_BACKEND_URL}/${resposne.data}`;
                //console.log(this.getUser.doctor.image);
              }
              else{
                alert("could not update Image")
              }
          })
      },


  },
  mounted() {
    AuthService.fetchdoctor(this.getUser.id)
        .then((response) => {
        if(response.status===200)
        {
          this.storeUser(response.data);
          this.localDoctor = this.getUser.doctor;
          this.localDoctor.image = `${process.env.VUE_APP_BACKEND_URL}/${this.localDoctor.image}`;
          this.status_form.status = parseInt(this.localDoctor.status);
          if(this.status_form.status === 0){
            this.activationbutton = 'Inactive';
          }
          else {
            this.activationbutton = 'Active';
          }
          console.log(this.localDoctor.image);
          this.edit_form.rate = this.localDoctor.rate;
          this.edit_form.offer_rate = this.localDoctor.offer_rate;
          this.edit_form.first_appointment_rate = this.localDoctor.first_appointment_rate;
          this.edit_form.report_followup_rate = this.localDoctor.report_followup_rate;
          this.edit_form.workplace = this.localDoctor.workplace;
          this.edit_form.designation = this.localDoctor.designation;
          this.edit_form.other_trainings = this.localDoctor.other_trainings;
        }
      })
  }
}
</script>

<style scoped>
.margintop{
  margin-top: 8px;
}
.uploading-image{
  display:flex;
  padding: 10px;
}
.img{
  height: 300px;
  width: 100%;
}
.textdecorationName{
  padding: 1px 0px 1px 1px;
  font-family: sans-serif;
  font-weight: bold;
}
.textmargin1px{
  margin-top: 1px;
}
.textColorBlue{
  color: #1A86D0;
  font-weight: bold;
}
.margin-lf-2px{
  margin-left: 10px;
}
.table-data{
  font-weight: bold;
  alignment: left;
  color: #0f6674;
}

</style>